export const updateExpirationOrder = (expirationOrder, toasts, toast) => {
    const updatedOrder = new Set();
    let inserted = false;
    expirationOrder.forEach((id) => {
        if (id === toast.id) {
            return;
        }
        const orderedToast = toasts.get(id);
        if (orderedToast?.expiresAt == null) {
            return;
        }
        if (!inserted && toast.expiresAt != null && toast.expiresAt < orderedToast.expiresAt) {
            updatedOrder.add(toast.id);
            inserted = true;
        }
        updatedOrder.add(id);
    });
    if (!inserted && toast.expiresAt != null) {
        updatedOrder.add(toast.id);
    }
    return updatedOrder;
};
//# sourceMappingURL=updateExpirationOrder.js.map